import * as tslib_1 from "tslib";
import { AfterContentInit, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { FormatNumberService } from 'src/app/shared/utils/format-number.service';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from '../../../shared/services/capture/capture.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { StringHelperService } from '../../../shared/services/helpers/string-helper.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
var FormEmployeeComponent = /** @class */ (function () {
    function FormEmployeeComponent(copyService, headerService, captureService, navigationService, abreCuentasService, parametersService, stringHelperService, formatNumber, requestService) {
        this.copyService = copyService;
        this.headerService = headerService;
        this.captureService = captureService;
        this.navigationService = navigationService;
        this.abreCuentasService = abreCuentasService;
        this.parametersService = parametersService;
        this.stringHelperService = stringHelperService;
        this.formatNumber = formatNumber;
        this.requestService = requestService;
        this.district_option = this.abreCuentasService.getDistricts();
        this.headerService.show(true, true, true);
    }
    FormEmployeeComponent.prototype.ngOnInit = function () {
        this.has_second_headline = this.abreCuentasService.getSecondHeadline();
        this.selectedOccupation = (!this.has_second_headline || !this.has_second_headline.has_second_headline)
            ? this.abreCuentasService.getOccupationSelected()
            : this.abreCuentasService.getOccupationSelectedSecondHeadline();
        // this.options = this.parametersService.getSetting(OpEnum.CITY_LIST);
        var productSelected = this.abreCuentasService.getproductSelected();
        this.productType = productSelected ? productSelected.product_type : '';
        this.officeInfo = (!this.has_second_headline || !this.has_second_headline.has_second_headline) ?
            this.abreCuentasService.getOfficeInfo(this.selectedOccupation.id + '') :
            this.abreCuentasService.getOfficeSecondHeadlineInfo(this.selectedOccupation.id + '');
        this.selectedCity = this.officeInfo.address.city;
        this.selected_district = this.selectedCity.district_id;
        if (this.productType === 'payroll') {
            this.officeInfo.company_nameInput = this.abreCuentasService.getAgreementSelected().agreement_name;
        }
    };
    /**
     * Summary Call after angular has fully started the component view, initialization of the form
     */
    FormEmployeeComponent.prototype.ngAfterContentInit = function () {
        var companyName = (!this.has_second_headline || !this.has_second_headline.has_second_headline)
            ? this.officeInfo.company_name
            : this.officeInfo.company_nameInput;
        this.formGroup = new FormGroup({
            'input-value-company': new FormControl(companyName, Validators.required),
            'input-value-address': new FormControl(this.officeInfo.address.addressInput, [Validators.required, Validators.minLength(4), Validators.maxLength(40), Validators.pattern(new RegExp(/^[Ññ\w-#/., ]+$/))]),
            'input-value-addressDetail': new FormControl(this.officeInfo.address.detail, [Validators.maxLength(40)]),
            'input-value-telephone': new FormControl(this.officeInfo.office_number, [Validators.pattern(/^\d{7,10}$/),
                Validators.maxLength(10)]),
        });
        if (this.productType === 'payroll') {
            return;
        }
        var controlCompany = this.formGroup.controls['input-value-company'];
        var regexp1 = new RegExp(/^(?!.*[ ]{2}).+$/);
        controlCompany.setValidators([Validators.required, Validators.minLength(2), Validators.maxLength(80), Validators.pattern(regexp1)]);
    };
    /**
     * Summary normalize address
     */
    FormEmployeeComponent.prototype.validateCompany = function () {
        var controlCompany = this.formGroup.controls['input-value-company'];
        return this.stringHelperService.normalizeCompany(controlCompany.value).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    };
    /**
     * Summary normalize address
     */
    FormEmployeeComponent.prototype.validateAddress = function () {
        var controladdress = this.formGroup.controls['input-value-address'];
        var controladdressdetail = this.formGroup.controls['input-value-addressDetail'];
        controladdress.setValue(controladdress.value.replace(/[^A-Za-z0-9\s#\-.]/g, '').replace(/\s{2,}/g, ' '));
        return this.stringHelperService.normalizeAddress(controladdress.value, controladdressdetail.value);
    };
    FormEmployeeComponent.prototype.getNumberFormat = function (value) {
        // const formatNumber = new FormatNumberService();
        return this.formatNumber.formatNumberPhone(value);
    };
    /**
     * Se ejecuta cada vez que se inicia la edición de número de teléfono
     *
     * *It executes each time begins the phone editing*
     */
    FormEmployeeComponent.prototype.inputPhone = function ($event) {
        var value = $event.target.value;
        var phone = this.getNumberFormat(value);
        $event.target.value = phone.clearValue;
    };
    /**
     * Se ejecuta cada vez que termina la edición de número de teléfono
     *
     * *It executes each time finish the phone editing*
     */
    FormEmployeeComponent.prototype.outPhone = function ($event) {
        var value = $event.target.value;
        var phone = this.getNumberFormat(value);
        $event.target.value = phone.format;
    };
    /**
     * Summary Telephone entry change event, error validation
     */
    FormEmployeeComponent.prototype.reactiveInputTelephone = function () {
        var controladdressTelephone = this.formGroup.controls['input-value-telephone'];
        controladdressTelephone.setValue(controladdressTelephone.value.slice(0, 10));
        controladdressTelephone.setValue(controladdressTelephone.value.replace(new RegExp(/[^\d]/), ''));
    };
    /**
     * Summary Address entry change event, error validation
     */
    FormEmployeeComponent.prototype.reactiveInputChangeAddress = function () {
        var controladdress = this.formGroup.controls['input-value-address'];
        controladdress.setValue(controladdress.value.replace(/[^A-Za-z0-9\s#\-.]/g, '').replace(/\s{2,}/g, ' '));
        this.reactiveErrorAddress = this.setValueByValidateBoolean(controladdress.valid, '', 'Por favor ingresa una dirección válida. Ej: Carrera 00# 00a - 00.');
    };
    FormEmployeeComponent.prototype.reactiveInputCompany = function () {
        var controladdressCompany = this.formGroup.controls['input-value-company'];
        controladdressCompany.setValue(controladdressCompany.value.replace(/[^A-Za-z0-9&\s]/g, '').replace(/\s{2,}/g, ' '));
        this.reactiveErrorCompany = this.setValueByValidateBoolean(controladdressCompany.valid, '', 'La empresa es requerida.');
    };
    FormEmployeeComponent.prototype.setValueByValidateBoolean = function (validValue, caseTrue, caseFalse) {
        return (validValue) ? caseTrue : caseFalse;
    };
    /**
     * Summary Event for select a option for list selected, and set value in Input
     * @param option
     */
    FormEmployeeComponent.prototype.selectOption = function (option) {
        if (option.value) {
            this.selectedCity = option.value;
            return;
        }
        this.selectedCity = {
            country_code: '',
            province_code: 0,
            city_code: '',
            description: '',
        };
    };
    /**
     * Summary next event validation
     */
    FormEmployeeComponent.prototype.next = function () {
        var _this = this;
        var body = {
            occupation_id: this.abreCuentasService.getOccupationSelected().id,
            company_name: this.validateCompany(),
            company_nameInput: this.formGroup.controls['input-value-company'].value,
            address: {
                city: this.selectedCity,
                address: this.validateAddress(),
                detail: this.formGroup.controls['input-value-addressDetail'].value,
                addressInput: this.formGroup.controls['input-value-address'].value,
            },
            office_number: this.formGroup.controls['input-value-telephone'].value,
        };
        this.officeInfo = body;
        if (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline) {
            this.abreCuentasService.setOfficeInfo(this.abreCuentasService.getOccupationSelected().id + '', this.officeInfo);
            this.abreCuentasService.getContactInfo().employment_number = this.formGroup.controls['input-value-telephone'].value !== '' ?
                this.formGroup.controls['input-value-telephone'].value : null;
        }
        else {
            this.abreCuentasService.setOfficeSecondHeadlineInfo(this.abreCuentasService.getOccupationSelected().id + '', this.officeInfo);
            this.abreCuentasService.getContactInfoSecondHeadline().employment_number =
                this.formGroup.controls['input-value-telephone'].value !== '' ?
                    this.formGroup.controls['input-value-telephone'].value : null;
        }
        if (this.abreCuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
            this.navigationService.nextStep('200');
            return;
        }
        this.captureService.sendProspectOfficeAddress(body).then(function (res) {
            if (!res) {
                return;
            }
            if (+res.status !== 200) {
                _this.navigationService.navigateToGeneralInformation('500');
            }
            else {
                _this.navigationService.nextStep('200');
            }
        }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); });
    };
    FormEmployeeComponent.prototype.getCitysEmployee = function (provence_id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestService.cityBranches(provence_id).then(function (resp) {
                            _this.city_option = resp.body;
                            _this.options = _this.city_option.map(function (data) {
                                var codeDaneEmployee = data.code_dane;
                                var codeDanelength = codeDaneEmployee.length - 3;
                                return {
                                    city_code: codeDaneEmployee.substring(codeDanelength),
                                    province_code: +codeDaneEmployee.substring(0, codeDanelength),
                                    description: data.city,
                                    district_id: data.district.district_id,
                                };
                            });
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FormEmployeeComponent.prototype.selectOptionProvidence = function (event) {
        var valueProvidence = event.value;
        if (valueProvidence && valueProvidence.trim() !== '') {
            this.selected_district = valueProvidence;
            this.getCitysEmployee(valueProvidence);
        }
        else {
            this.city_option = undefined;
            this.selectedCity = { city_code: '', country_code: '', province_code: 0, description: '' };
            this.selected_district = undefined;
        }
    };
    return FormEmployeeComponent;
}());
export { FormEmployeeComponent };
